class MobileMenuDrawer extends HTMLElement {
    constructor() {
      super();
      this.hamburgerWrapper = null;
      this.headerMenuDrawer = null;
      this.mediaQuery = window.matchMedia('(min-width: 1025px)');
      this.boundHandleMediaChange = this.handleMediaChange.bind(this);
    }
  
    connectedCallback() {
      this.childlinkLinks = this.querySelectorAll('[data-nav-childlink-link]');
      this.childlinkLinksBack = this.querySelectorAll('[data-mobile-childlink-back]');
      
      this.initChildLinksClick();
  
      this.hamburgerWrapper = this.querySelector('[data-hamburger-Wrapper]');
      this.headerMenuDrawer = document.querySelector('hamburger-drawer-tabs');
  
      this.closeButton = this.querySelector('[data-offcanvas-close]');
      this.headerMenuDrawerTrigger = document.querySelector('[data-mobile-drawer-button]');
      this.headeractionMenuDrawerTrigger = document.querySelector('[data-mobile-action-drawer-button]');
  
      if (this.headerMenuDrawerTrigger) {
        this.headerMenuDrawerTrigger.addEventListener('click', () => this.openDrawer());
      }
      if (this.headeractionMenuDrawerTrigger) {
        this.headeractionMenuDrawerTrigger.addEventListener('click', () => this.openDrawer());
      }
      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.closeDrawer());
      }
  
      if (this.hamburgerWrapper && this.headerMenuDrawer) {
        this.initHamburger();
      }
  
      // ✅ Listen for desktop/mobile switch
      this.mediaQuery.addEventListener('change', this.boundHandleMediaChange);
      this.handleMediaChange(this.mediaQuery);
  
      this.hamburgerDrawer();
      if (Shopify.designMode) {
        this.observeDesignMode();
      }
    }
    observeDesignMode() {
    
      this.addEventListener('shopify:section:load', this.showHamburger);
      this.addEventListener('shopify:section:unload', this.hideHamburger);
      this.addEventListener('shopify:section:select', this.showHamburger);
      this.addEventListener('shopify:section:deselect', this.hideHamburger);
    }
  
    showHamburger = () => {
      this.toggleHamburger(false);
  
    };
  
    hideHamburger = () => {
      this.toggleHamburger(true);
  
    };
    toggleHamburger(hide = true) {
      const nav = document.querySelector('[data-hamburger-nav]');
      const button = document.querySelector('[data-hamburger-button-wrapper]');
      if (!nav || !button) return;
  
      nav.classList.toggle('hidden', hide);
      button.classList.toggle('hidden', hide);
    }
  
    disconnectedCallback() {
      this.mediaQuery.removeEventListener('change', this.boundHandleMediaChange);
    }
    hamburgerDrawer() {
      this.querySelectorAll('[data-main-hamburger]').forEach(tabsContainer => {
        const tabButtons = tabsContainer.querySelectorAll('[data-link-hamburger]');
        const tabContents = tabsContainer.querySelectorAll('[data-block-hamburger]');
  
        const activateTab = (button) => {
          const targetId = button.getAttribute('data-tab');
          const targetContent = tabsContainer.querySelector(`#${targetId}`);
          if (!targetContent) return;
  
          tabButtons.forEach(btn => btn.classList.remove('active'));
          tabContents.forEach(content => {
            content.classList.remove('active');
            // If the element is empty (no child nodes or text)
            const isEmpty = !content.innerHTML.trim();
            if (isEmpty) {
              content.classList.add('no-subdata');
            } else {
              content.classList.remove('no-subdata'); // Optional: clean up if previously added
            }
          });
  
  
          button.classList.add('active');
          targetContent.classList.add('active');
        };
  
        tabButtons.forEach(button => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            activateTab(button);
          });
  
          button.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              activateTab(button);
            }
          });
          // button.addEventListener('focus', () => {
          //   activateTab(button);
          // });
        });
      });
  
      
      // Global click handlers
      this.addEventListener('click', (e) => {
        const navLink = e.target.closest('[data-nav-hamburger-link]');
        const backButton = e.target.closest('[data-hamburger-back]');
  
        if (navLink) {
          const mainParent = navLink.closest('[data-hamburger-nav]');
          const parent = navLink.closest('[data-hamburger-megamenu-item]');
          const siblings = parent?.parentElement?.querySelectorAll('[data-hamburger-megamenu-item]');
          if (mainParent && parent && siblings) {
            mainParent.classList.add('hamburger-megamenu-menus-open');
            siblings.forEach(item => item.classList.remove('active'));
            parent.classList.add('active');
            const focusElement = parent.querySelector('.hamburger-megamenus-menuswrap');
            // if (focusElement) {
            //   trapFocus(focusElement);
            // }
          }
        }
  
        if (backButton) {
          const mainParent = backButton.closest('[data-hamburger-nav]');
          document.querySelectorAll('[data-hamburger-megamenu-item].active').forEach(item => {
            item.classList.remove('active');
          });
          if (mainParent) {
            mainParent.classList.remove('hamburger-megamenu-menus-open');
          }
        }
      });
    }
  
    openDrawer() {
      this.classList.add('mobile-menu-open');
      document.body.classList.add('overflow-hidden');
    }
  
    closeDrawer() {
      this.classList.remove('mobile-menu-open');
      document.body.classList.remove('overflow-hidden');
    }
  
    handleMediaChange(e) {
      if (e.matches) {
        // >=1025px desktop
        this.closeDrawer();
      } else {
        // <1025px mobile
        if (this.hamburgerWrapper && this.headerMenuDrawer) {
          this.initHamburger();
        }
      }
    }
  
    initChildLinksClick() {
      this.childlinkLinks.forEach(childlink => {
        childlink.addEventListener('click', (e) => {
          e.preventDefault();
          const clickedMenu = childlink.closest('[data-child-menu]');
          if (clickedMenu) clickedMenu.classList.toggle('active-submenu');
        });
      });
  
      this.childlinkLinksBack.forEach(childlinkBack => {
        childlinkBack.addEventListener('click', (e) => {
          e.preventDefault();
          const clickedMenu = childlinkBack.closest('[data-child-menu]');
          if (clickedMenu) clickedMenu.classList.remove('active-submenu');
        });
      });
    }
  
    initHamburger() {
      const checkVisibility = this.headerMenuDrawer.getAttribute('data-visibility-on');
      if (checkVisibility === 'desktop') return;
  
      const template = this.headerMenuDrawer.querySelector('template');
      if (!template) return;
  
      this.hamburgerWrapper.innerHTML = '';
      const clone = template.content.cloneNode(true);
  
      // const navWithAttr = clone.querySelector('[data-hamburger-nav]');
      // if (navWithAttr) navWithAttr.removeAttribute('data-hamburger-nav');
  
      // const navWithColor = clone.querySelector('[data-color-scheme]');
      // if (navWithColor) {
      //   navWithColor.classList.remove('hamburger-nav');
      //   navWithColor.classList.add('hamburger-mobilenav');
      //   const colorClass = navWithColor.getAttribute('data-color-scheme');
      //   if (colorClass) navWithColor.classList.remove(colorClass);
      // }
  
      this.hamburgerWrapper.appendChild(clone);
      this.hamburgerWrapper.classList.remove('hidden');
  
      // Add submenu toggles for hamburger menu
      this.hamburgerChildLink = this.querySelectorAll('[data-nav-hamburger-link]');
      this.hamburgerChildLinkBack = this.querySelectorAll('[data-hamburger-back]');
  
      if (this.hamburgerChildLink) {
        this.hamburgerChildLink.forEach(childlink => {
          childlink.addEventListener('click', (e) => {
            // e.preventDefault();
            const mainParent = childlink.closest('.hamburger-mobilenav');
            const parent = childlink.closest('[data-hamburger-megamenu-item]');
            const siblings = parent?.parentElement?.querySelectorAll('[data-hamburger-megamenu-item]');
            if (mainParent && parent && siblings) {
              mainParent.classList.add('hamburger-megamenu-menus-open');
              siblings.forEach(item => item.classList.remove('active'));
              parent.classList.add('active');
            }
          });
        });
      }
  
      if (this.hamburgerChildLinkBack) {
        this.hamburgerChildLinkBack.forEach(childlinkBack => {
          childlinkBack.addEventListener('click', (e) => {
            e.preventDefault();
            const mainParent = childlinkBack.closest('.hamburger-mobilenav');
            document.querySelectorAll('[data-hamburger-megamenu-item].active').forEach(item => {
              item.classList.remove('active');
            });
            if (mainParent) {
              mainParent.classList.remove('hamburger-megamenu-menus-open');
            }
          });
        });
      }
  
      this.hamburgerDrawer();
    }
}
customElements.define('mobile-menu-drawer', MobileMenuDrawer);
  
  
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.container = this.dataset.headerContainer;
    } 
  
    connectedCallback() {
      this.header = document.querySelector('.header-section');
      const menuDrawerContainer = document.querySelector('[data-menu-drawer-container]');
  
      if (menuDrawerContainer && this.container) {
        menuDrawerContainer.className = menuDrawerContainer.className
          .replace(/\bcontainer(?:-[^\s]+)?\b/g, '')
          .trim();
        menuDrawerContainer.classList.add(this.container);
      }
  
      this.setHeaderHeight();
  
      if (!this.getAttribute('data-sticky-type')){
        document.body.classList.add('sticky-header-none');
        return;
      } 
  
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};
  
      window.matchMedia('(max-width: 990px)')
        .addEventListener('change', this.setHeaderHeight.bind(this));
      window.addEventListener('resize', this.setHeaderHeight.bind(this));
  
      if (this.headerIsAlwaysSticky) {
        this.classList.add('header-sticky');
      }
  
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.headerTop = 800;
      this.isAnimationEnabled = false;
      this.predictiveSearch = this.querySelector('predictive-search');
  
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
  
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
  
      // ✅ CALL ONCE
      this.headerAttr();
  
      this.createObserver();
    }
  
    headerAttr(){
      const slideshow = document.querySelector('main interactive-slideshow');
      if (!slideshow) return;
  
      this.isAnimationEnabled = slideshow.dataset.animation === 'true';
  
      const section = slideshow.closest('.shopify-section');
      if (!section) return;
  
      const sections = Array.from(
        document.querySelectorAll('main > .shopify-section')
      );
  
      this.sectionIndex = sections.indexOf(section);
    }
  
    setHeaderHeight() {
      document.documentElement.style
        .setProperty('--header-height', `${this.offsetHeight}px`);
    }
  
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
  
      document.removeEventListener('shopify:section:load', this.headerAttrHandler);
      document.removeEventListener('shopify:section:unload', this.headerAttrHandler);
      document.removeEventListener('shopify:section:select', this.headerAttrHandler);
      document.removeEventListener('shopify:section:deselect', this.headerAttrHandler);
    }
  
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
  
      observer.observe(this.header);
  
      // ✅ FIXED EVENT BINDING
      this.headerAttrHandler = this.headerAttr.bind(this);
  
      document.addEventListener('shopify:section:load', this.headerAttrHandler);
      document.addEventListener('shopify:section:unload', this.headerAttrHandler);
      document.addEventListener('shopify:section:select', this.headerAttrHandler);
      document.addEventListener('shopify:section:deselect', this.headerAttrHandler);
    }
  
    onScroll() {
      let scroll_top;
        if (this.sectionIndex === 0 && this.isAnimationEnabled) {
        scroll_top = this.headerTop ;
      } else {
        scroll_top = this.headerBounds.bottom;
      }
  
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
  
      if (scrollTop > this.currentScrollTop && scrollTop > scroll_top) {
        this.classList.add('transparent-none');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } 
      else if (scrollTop < this.currentScrollTop && scrollTop > scroll_top) {
        this.classList.add('transparent-none');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
  
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
  
          requestAnimationFrame(this.hide.bind(this));
        }
      } 
      else if (scrollTop <= this.headerBounds.top) {
        this.classList.remove('transparent-none');
        requestAnimationFrame(this.reset.bind(this));
      }
  
      this.currentScrollTop = scrollTop;
    }
  
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.classList.add('header-hidden', 'header-sticky');
      document.body.classList.add('header-ishidden');
      this.closeSearchModal();
    }
  
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.classList.add('header-sticky', 'animate');
      this.classList.remove('header-hidden');
      document.body.classList.remove('header-ishidden');
    }
  
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.classList.remove('header-hidden', 'header-sticky', 'animate');
      document.body.classList.remove('header-ishidden');
    }
  
    closeSearchModal() {
      this.searchModal = this.searchModal || 
        this.header.querySelector('details-modal');
    }
  }
  
  customElements.define('sticky-header', StickyHeader);